import React from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import FaceIcon from '@mui/icons-material/Face';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CameraEnhanceIcon from '@mui/icons-material/CameraEnhance';

const menuItems = [
  {
    title: 'Dashboard',
    path: '/',
    icon: <DashboardIcon />
  },
  {
    title: 'Validação',
    path: '/biometric',
    icon: <FaceIcon />
  },
  {
    title: 'Liveness',
    path: '/liveness',
    icon: <CameraEnhanceIcon />
  },
  {
    title: 'Usuários',
    path: '/users',
    icon: <PeopleIcon />
  },
  {
    title: 'Administradores',
    path: '/user-admins',
    icon: <AdminPanelSettingsIcon />
  },
  {
    title: 'API Keys',
    path: '/api-keys',
    icon: <VpnKeyIcon />
  }
];

interface SidebarProps {
  open: boolean;
  onClose: () => void;
  variant: 'permanent' | 'temporary';
}

const Sidebar = ({ open, onClose, variant }: SidebarProps) => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      variant={variant}
      sx={{
        width: isMobile ? '100%' : 280,
        '& .MuiDrawer-paper': {
          width: isMobile ? '100%' : 280,
          boxSizing: 'border-box',
          backgroundColor: 'background.paper',
          borderRight: 1,
          borderColor: 'divider',
        },
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="h6">
          Singular Face
        </Typography>
      </Box>
      <List>
        {menuItems.map((item) => (
          <ListItem
            button
            component={Link}
            key={item.path}
            to={item.path}
            selected={location.pathname === item.path}
            onClick={isMobile ? onClose : undefined}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.title} />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar; 